import {Grid, Header, Image, Segment} from "semantic-ui-react";
import styles from "../../../components/Components.module.css";
import React from "react";
import {Link} from "react-router-dom";
import Rij from "../../Common/Rij";

const Portfolio = ({screenWidth}) => {
    const isMobile = screenWidth <= 768;  // Define your mobile breakpoint here
    return(
        <>
            <Segment className={styles.segmentWithBorder} style={{padding: '0em 0em', borderBottom: '0px',
                maxWidth: isMobile ? 'inherit': '70%',
                marginLeft: isMobile ? 'inherit': 'auto',
                marginRight: isMobile ? 'inherit': 'auto'
            }}
                     vertical basic>
                <Grid container stackable centered={isMobile ? true : null } verticalAlign='middle' >
                    <Rij header={'Boeken'}>
                        <Header as={'h1'} style={{fontSize: '3.6em'}}>Boeken</Header>
                        <p className={styles.rijP} style={{fontStyle: 'inherit', marginTop: '1em'}}>
                        </p>
                    </Rij>
                    <Grid.Row style={{minHeight: '80vh', marginBottom: '3em'}}>
                        <Grid.Column width={6} textAlign='center' style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <Segment basic style={{
                                backgroundColor: 'transparent',
                                padding: '3em 0em',
                                marginBottom: '3em',
                                borderRadius: '30px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                maxWidth: isMobile ? '80%' : '400px'
                            }}>
                                <Header as='h3'
                                        style={{fontSize: '1.6em', textAlign: 'left', alignSelf: 'flex-start'}}>
                                    Zelfs vogels zijn verlegen
                                </Header>
                                <p style={{
                                    fontSize: '1.2em',
                                    textAlign: 'justify',
                                    textJustify: 'inter-word',
                                    fontStyle: 'italic',
                                }}>
                                    ‘In een wereld die steeds meer draait om zichtbaarheid en zelfpromotie is het niet
                                    handig om stil te zijn.
                                    Daarom doen we met z’n allen hard ons best om iedere vorm van verlegenheid te
                                    onderdrukken, verhullen en op te poetsen. Verlegen mensen worden ondertussen om de
                                    oren geslagen met goedbedoelde adviezen: ‘Laat jezelf wat meer zien!’
                                    Manouk van Egmond is al zo lang ze zich kan herinneren verlegen en meent dat dit
                                    geen afwijking of ziekte is, maar een doodnormale eigenschap.
                                    In dit boek, waarin vele wetenschappers, filosofen en ervaringsdeskundigen aan het
                                    woord komen, vertelt ze je over de rol van verlegenheid in haar leven en de
                                    maatschappij.’
                                </p>
                                <p style={{
                                    fontSize: '1.2em',
                                    textAlign: 'justify',
                                    textJustify: 'inter-word',
                                    marginBottom: '3em',
                                }}>
                                    Ik schreef een
                                    <Link to={'https://www.walburgpers.nl/nl/book/9789462499393/zelfs-vogels-zijn-verlegen'}
                                          className={styles.standardLink}> non-fictieboek</Link> over verlegenheid,
                                    dat je ook kunt lezen als een autobiografie, naar aanleiding van de reacties op
                                    mijn <span style={{fontStyle: 'italic'}}>NRC</span>-essay
                                    <Link to={'https://www.nrc.nl/nieuws/2021/12/13/ik-ben-verlegen-en-je-hoeft-me-daar-niet-van-te-genezen-a4068770'}
                                          className={styles.standardLink}> ‘Ik ben verlegen en je hoeft mij daar niet van te genezen’</Link>.
                                    Ironisch genoeg werd ik veelvuldig geïnterviewd over dit boek en mijn verlegenheid,
                                    bijvoorbeeld door
                                    <Link to={'https://www.parool.nl/ps/waarom-verlegenheid-geen-gebrek-is-met-alleen-brutale-wezens-red-je-het-niet~bb96ea1d/?referrer=https://www.google.com/'}
                                          className={styles.standardLink} style={{fontStyle: 'italic'}}> Het Parool</Link>,
                                    <Link to={'https://www.trouw.nl/binnenland/pas-als-je-uit-je-schulp-kruipt-word-je-leuk-gevonden-dacht-verlegen-auteur-manouk-van-egmond-tot-nu~b20d65ee/?referrer=https://www.google.com/'}
                                          className={styles.standardLink} style={{fontStyle: 'italic'}}> Trouw</Link>,
                                    <Link to={'https://www.nporadio1.nl/fragmenten/villa-vdb/f0ea1f5c-1363-4d1c-966f-834e24058f27/2023-10-10-de-kracht-van-verlegen-zijn'}
                                          className={styles.standardLink} style={{fontStyle: 'italic'}}> Villa VdB</Link> en
                                    <Link to={'https://www.vrt.be/vrtmax/podcasts/radio-1/d/de-wereld-van-sofie/5/verlegenheid/'}
                                          className={styles.standardLink} style={{fontStyle: 'italic'}}> De wereld van Sofie</Link>. Ook
                                    schreef ik opnieuw een
                                    <Link to={'https://www.nrc.nl/nieuws/2023/10/10/dit-is-geen-keuze-en-al-helemaal-geen-gebrek-a4176654#:~:text=Het%20is%20niet%20alleen%20onzinnig,agressieve%20aansporingen%20van%20hun%20omgeving.'}
                                          className={styles.standardLink}> verhaal</Link> voor <span style={{fontStyle: 'italic'}}>NRC</span> op de dag dat het boek werd gepubliceerd.
                                    <br/><br/>

                                    Mail naar <a href='mailto:publiciteit@walburgpers.nl' className={styles.standardLink}>publiciteit@walburgpers.nl</a> voor persverzoeken en lezingaanvragen.
                                </p>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8} floated='right' textAlign='center'>
                            <Link to={'https://www.walburgpers.nl/nl/book/9789462499393/zelfs-vogels-zijn-verlegen'}>
                            <Image rounded src='img/02_Verlegen_vogels.jpg' size='large' style={{
                                display: 'inline-block',
                                borderRadius: '5px',
                                boxShadow: '0px 5px 50px #00000029',
                                backgroundColor: '#fafafa',
                                maxWidth: isMobile ? '80%' : null
                            }}/></Link>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>

            <Segment style={{padding: '0em 0em' ,
                maxWidth: isMobile ? 'inherit' : '70%',
                marginLeft:isMobile ? 'inherit' : 'auto',
                marginRight: isMobile ? 'inherit': 'auto'
            }} vertical basic>
                <Grid container stackable verticalAlign='middle'>
                    <Grid.Row centered style={{minHeight: '80vh', margin: '3em 0em'}}>
                        {!isMobile && (
                        <Grid.Column width={9} floated='left' style={{borderRadius: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Image src='img/Vrij-cover-acrobaten.jpg' size='huge'  style={{display: 'inline-block', borderRadius: '5px', boxShadow: '0px 5px 50px #00000029', backgroundColor: '#fafafa'}}/>
                        </Grid.Column>)}
                        <Grid.Column width={6} textAlign='center' style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column'}}>
                            <Segment basic style={{
                                padding: '3em 0em',
                                marginBottom: '3em',
                                borderRadius: '30px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                maxWidth: isMobile ? '80%' : '400px'
                            }}>

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                }}>
                                    <Header as='h3' style={{fontSize: '1.6em', textAlign: 'left' }}>
                                        Vrij
                                    </Header>
                                    <p style={{
                                        fontSize: '1.2em',
                                        textAlign: 'justify',
                                        textJustify: 'inter-word',
                                        fontStyle: 'italic'
                                    }}>
                                        ‘Van sneeuwklokjes verzamelen tot showworstelen [...].
                                        Bijna vijf jaar verscheen de rubriek ‘Vrij’ in de weekendkrant van <span style={{fontStyle: 'italic'}}>NRC</span>,
                                        waarin werd vastgelegd wat Nederlanders doen als ze niet werken.
                                        En nu is er dit boek, met 52 bijzondere ontmoetingen.
                                        Schrijvers Sanneke van Hassel en Manouk van Egmond, en fotografen
                                        Folkert Koelewijn en Peter de Krom maakten de meeste portretten van recreërend
                                        Nederland. Maar ook fotografen Ilvy Njiokiktjien en Lars van den Brink, en
                                        auteurs Raoul de Jong en Astrid de Rooij leverden bijdragen. Vrij - wat
                                        Nederlanders doen als ze niet werken is de ultieme ode aan de Nederlandse hobbyist.’
                                    </p>
                                    <p style={{
                                        fontSize: '1.2em',
                                        textAlign: 'justify',
                                        textJustify: 'inter-word',
                                    }}>
                                        Ik was jarenlang co-auteur van de <span style={{fontStyle: 'italic'}}>NRC</span>-rubriek ‘Vrij’, waarin Nederlanders met
                                        bijzondere hobby's werden geportretteerd. In dit
                                        <Link to={"https://www.bol.com/nl/nl/p/vrij/9300000112528409/"}
                                              className={styles.standardLink}> boek</Link> zijn de leukste
                                        afleveringen gebundeld. Mijn favorietjes zijn de
                                        <Link to={'https://www.nrc.nl/nieuws/2020/03/12/vrij-a3993394'}
                                              className={styles.standardLink}> poppenhuismevrouw</Link> die haar
                                        droomhuis in elkaar had geknutseld,  het meisje dat aan
                                        <Link to={'https://www.nrc.nl/nieuws/2022/06/17/vrij-a4133547'}
                                              className={styles.standardLink}> stokpaardrijden</Link> doet, en de
                                        <Link to={'https://www.nrc.nl/nieuws/2019/11/14/vrij-a3980238'}
                                              className={styles.standardLink}> koivishouder</Link> die
                                        ‘een soort IJsselmeer’ in zijn achtertuin had gebouwd.
                                        <br/><br/>
                                    </p>
                                </div>
                            </Segment>
                        </Grid.Column>
                        {isMobile && (
                            <Grid.Column width={8} textAlign='center'>
                                <Image src='img/Vrij-cover-acrobaten.jpg' size='huge'  style={{
                                    maxWidth: '80%',
                                    display: 'inline-block',
                                    borderRadius: '5px',
                                    boxShadow: '0px 5px 50px #00000029',
                                }}/>
                            </Grid.Column>)}
                    </Grid.Row>
                </Grid>
            </Segment>


        </>
    );
}

export default Portfolio